export const layoutConfigMap: Record<string, { hideFooter?: boolean; hideNavbar?: boolean }> = {
  "/:lng/scan-doc/*": {
    hideFooter: true,
    hideNavbar: false,
  },
};
